<template >
  <!--
  <pre>placehodler inputObj{{inputObj}}</pre>
   -->
  <h3>{{inputObj.params.title}}</h3>
  <p v-if="inputObj.params.desc">{{inputObj.params.desc}}</p>


  <template
    v-if="inputObj.params.checkbox_is_generated"
  >

    <div class="form-check form-switch">
      <input
          v-model="inputModel.is_generated"
          class="form-check-input"
          type="checkbox"
          role="switch"
          :id="checkboxId"
      >
      <label
          class="form-check-label"
          :for="checkboxId"
      >
        {{ $t('inputSegment.general.is_generated_title')}}
      </label>
    </div>
  </template>

  <template
      v-if="inputObj.params.is_json_data_transfer"
  >
    <textarea
        v-model="inputModel.data"
        style="visibility: hidden"
        class="form"
    >
    </textarea>
  </template>


  <template v-if="inputObj.params.display_type == 'tags'">
    <ul class="list-group">
      <li
          v-for="tag in inputObj.obsah.data"
        class="list-group-item"
      >
        {{tag.title}}
      </li>
    </ul>

  </template>
  <template v-else-if="inputObj.params.display_type == 'contents'">
  [contents]
  </template>

    <!--
  <display-debug>
    <template #debugView>inputObj.obsah: {{inputObj.obsah}}</template>
  </display-debug>

  <display-debug>
    <template #debugView>inputModel: {{inputModel}}</template>
  </display-debug>

  <display-debug>
    <template #debugView>inputObj.params: {{inputObj.params}}</template>
  </display-debug>
-->
</template>

<script>

import DisplayDebug from "@/components/general/DisplayDebug.vue";
import {generateRandomString} from "@/utils/general";

export default {
  name: "PlaceholderSegment",
  components: {DisplayDebug},
  props: {
    "segmentsObj": [Object, Array],
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, Number, String],
    "lang": {
      type: [Object],
      required: false,
    },
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
    "config": {
      type: [Object],
      required: false,
    },
  },
  data() {
    return {
      inputModel: {
        status: true,
        is_generated: false,
        data: '{}'
      },
      checkboxId: null,
    }
  },
  emits: ['update:modelValue'],
  mounted() {
    console.log("dev segment mounted inputObj", this.inputObj.obsah)
    this.checkboxId = this.generateRandomString(50)
    //obsah data
    if (
        this.inputObj
        && this.inputObj.obsah
        && this.inputObj.obsah.data
    ) {
      this.inputModel.data = JSON.stringify(this.inputObj.obsah.data)
    }
  //obsah generated status
    if (
        this.inputObj
        && this.inputObj.obsah
        && this.inputObj.obsah.is_generated
    ) {
      this.inputModel.is_generated = this.inputObj.obsah.is_generated
    }
  },
  watch: {
    inputObj: {
      handler() {
        //  this.inputModel = this.inputObj.val;
      },
      deep: true,
      immediate: true
    },
    inputModel: {
      handler(newVal, oldVal) {
        if(typeof oldVal != "undefined") {
          //console.log("dev segment watch X1", newVal, oldVal)
          const emitData = {...newVal};
          if(emitData.data) {
            //console.log("dev segment watch inputModel 2", emitData.data)
            try {
              emitData.data = JSON.parse(emitData.data)
            }catch (e) {
              console.log("dev segment watch inputModel ERR", e, emitData.data)
            }

            //
          }else{
            emitData.data = {}
          }
          this.$emit('update:modelValue', emitData )

        }



      },
      deep: true,
      immediate: true



    },
  },


};
</script>
<script setup lang="ts">
</script>